import React, { useEffect, useState } from "react";
import { Button, Select, Layout, Space, PageHeader, Row } from "antd";
import { useLocation, useHistory } from "react-router-dom";

import Home from "./Home";
import Menu from "./Menu";
import Story from "./Story";
import Catering from "./Catering";
import ThemePopup from "./themePopup";
import ThemePreview from "./ThemePreview";

import "./style.scss";

const { Content } = Layout;
function Theme() {
  const [menu, setMenu] = useState("homePage");
  const [isPreview, setIsPreview] = useState(false);
  const [isThemePopupOpen, setIsThemePopupOpen] = useState(false);
  const [theme, setTheme] = useState("LIGHT");
  



  const location = useLocation();
  const history = useHistory();

  const handleMenuChange = (value) => {
    setMenu(value)
     console.log(value)

  history.push({
    pathname: location.pathname,
    search: `build=${value}`
  });
  };

  useEffect(()=>{
    const params = new URLSearchParams(location.search);
    const menu = params.get("build");
    setMenu(menu ?? 'homePage')
    
  },[location])

  const isFoodLuvTrail = location.pathname
    ?.toString()
    .includes("foodluv-trial");

  return (
    <Layout className="u-page-layout">
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
          className="page-header-business"
            title={
              isFoodLuvTrail ? (
                <div className="flex items-center">
                  <div
                    className="cursor-pointer flex"
                    onClick={() => history.goBack()}
                  >
                    <svg
                      width="25"
                      height="16"
                      viewBox="0 0 25 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7V9L25 9V7Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div className="ml-1 ant-page-header-heading-title">
                    Website Builder
                  </div>
                </div>
              ) : (
                "Website Builder"
              )
            }
            extra={[
              <Row >
              <Button
                type="link"
                
                size="large"
                className="mr-1"
                onClick={() => setIsThemePopupOpen(true)}
              >
                Update Theme
              </Button>,
              <Select
                defaultValue="homePage"
                onChange={(e) => handleMenuChange(e)}
                value={menu}
                className="mr-1"
                size="large"
                style={{ width: 170, color: "#C32340" }}
                options={[
                  { value: "homePage", label: "Home Page" },
                  { value: "menu", label: "Menu Page" },
                  { value: "story", label: "Story Page" },
                  { value: "catering", label: "Catering Page" },
                ]}
              />,
              <Button
                type="primary"
                className="custom-btn"
                // onClick={() =>
                //   isFoodLuvTrail
                //     ? history.push("/foodluv-trial/preview-website")
                //     : setIsPreview(!isPreview)
                // }
                onClick={()=>   window.open("/preview", "_blank")}
              >
                Preview
              </Button>,
              </Row>
            ]}
          />
          <div className="content-container-business">
            {isPreview ? (
              <ThemePreview />
            ) : (
              <>
                {(() => {
                  if (menu === "homePage") {
                    return <Home isPreview={isPreview} />;
                  } else if (menu === "menu") {
                    return <Menu isPreview={isPreview} />;
                  } else if (menu === "story") {
                    return <Story isPreview={isPreview} />;
                  } else if (menu === "catering") {
                    return <Catering isPreview={isPreview} />;
                  }
                })()}
              </>
            )}
          </div>
          <ThemePopup
            open={isThemePopupOpen}
            close={() => setIsThemePopupOpen(false)}
            theme={theme}
            setTheme={setTheme}
          />
        </Space>
      </Content>
    </Layout>
  );
}

export default React.memo(Theme);
